angular.module('picmonicng').factory('EditorService', [
  '$rootScope',
  '$filter',
  '$q',
  '$modal',
  '$state',
  'HALResource',
  'Picmonics',
  'PermissionsService',
  'UserService',
  'Upload',
  'WorkflowService',
  'toaster',
  'LearnService',
  'AudioService',
  '$timeout',
  'FactsResource',
  'Tracks',
  function (
    $rootScope,
    $filter,
    $q,
    $modal,
    $state,
    HALResource,
    Picmonics,
    PermissionsService,
    UserService,
    Upload,
    WorkflowService,
    toaster,
    LearnService,
    AudioService,
    $timeout,
    FactsResource,
    Tracks
  ) {
    var defaults = {
      assetStatus: [],
      assetsLoaded: false,
      imagesQuery: '',
      imagesLoading: false,
      imagesSearchResults: [],
      imagesPagination: {},
      imagesSearchSubType: 'images',
      backgroundsQuery: '',
      backgroundsLoading: false,
      backgroundsSearchResults: [],
      backgroundsPagination: {},
      backgroundLoading: false,
      editingBackground: false,
      currentCard: {},
      halOpen: false,
      halReset: false,
      halTarget: false,
      currentBackground: null,
      backgroundVisible: true,
      currentFacts: [],
      factsOpen: true,
      topicTypes: [],
      mode: 'editor',
      history: [],
      loading: false,
      summaryOpen: false,
      editingMembers: null,
      tab: null,
      workflow: false,
      returnTo: false,
      returnAfterFact: false,
      audioType: 'educational',
      audioLoaded: false,
    };

    var EditorService = {
      getCard: function (slug) {
        var resolvedData = {};

        return $q(function (resolve, reject) {
          resolvedData.currentCard = Picmonics.get({ slug: slug });
          resolvedData.currentCard.$promise.then(
            function () {
              Picmonics.query(
                {
                  card_id: resolvedData.currentCard.card_id,
                  isEditor: 1,
                  resource: 'facts',
                },
                function (facts) {
                  var count = 1;
                  for (var a in facts) {
                    if (!facts[a].header && facts[a].entity_type_id != 1) {
                      facts[a].display_order = count;
                      facts[a].new_audio = facts[a].new_audio || [];
                      count++;
                      if (facts[a].characters) {
                        for (var b in facts[a].characters) {
                          if (facts[a].characters[b].animation) {
                            var parts = facts[a].characters[b].animation.split(' ');
                            facts[a].characters[b].animation_type = parts[0];
                            facts[a].characters[b].animation_speed = parts[1];
                          }
                        }
                      }
                    }
                  }
                  resolvedData.currentFacts = facts;

                  if (resolvedData.currentCard.in_workflow) {
                    WorkflowService.getPicmonicWorkflow(resolvedData.currentCard.card_id);
                  }

                  resolve(resolvedData);
                },
                function () {
                  reject();
                }
              );
            },
            function () {
              reject();
            }
          );
        });
      },

      currentFact: function () {
        return this.tab == 'topic'
          ? this.primaryFact()
          : $filter('filter')(this.currentFacts, {
              selected: true,
            })[0];
      },

      primaryFact: function () {
        return $filter('filter')(this.currentFacts, {
          is_primary: 1,
        })[0];
      },

      nextFact: function () {
        var self = this;

        function goToNextFact() {
          var filteredFacts = $filter('filter')(self.currentFacts, {
            header: '!1',
          });
          var nextFact = filteredFacts[$filter('arrayPos')(filteredFacts, true, 'selected') + 1];

          if (nextFact) {
            self.selectFact(nextFact);
          } else {
            self.clearSelectedFact();
            if (self.tab === 'audio') {
              EditorService.selectTab('category');
            }
          }
        }

        if (AudioService.recording) {
          self.stopRecordingAudio().then(function () {
            goToNextFact();
          });
        } else {
          goToNextFact();
        }
      },

      pausetextToSpeech: function () {
        this.ttsAudio.pause();
        this.playingTTS = false;
      },

      textToSpeech: function (text) {
        if (!text || this.playingTTS) {
          return;
        }
        var self = this;
        // Initialize the Amazon Cognito credentials provider
        AWS.config.region = 'us-east-1';
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: 'us-east-1:0dd6d4b0-ef87-4f04-a155-94cf9b69a022',
        });

        // Function invoked by button click

        // Create the JSON parameters for getSynthesizeSpeechUrl
        var speechParams = {
          OutputFormat: 'mp3',
          SampleRate: '24000',
          Text: text,
          TextType: 'text',
          VoiceId: self.currentCard.narrator,
          Engine: 'neural',
        };

        // Create the Polly service object and presigner object
        var polly = new AWS.Polly({ apiVersion: '2016-06-10' });
        var signer = new AWS.Polly.Presigner(speechParams, polly);

        // Create presigned URL of synthesized speech file
        signer.getSynthesizeSpeechUrl(speechParams, function (error, url) {
          $rootScope.$apply(function () {
            if (error) {
              toaster.error(error);
            } else {
              self.ttsAudio = new Audio(url);
              self.ttsAudio.addEventListener('ended', function () {
                $rootScope.$apply(function () {
                  self.playingTTS = false;
                });
              });
              self.ttsAudio.play();
              self.playingTTS = true;
            }
          });
        });
      },

      saveCard: function () {
        var self = this;

        if (!self.loading) {
          self.loading = true;

          if (!UserService.user.ugc_license) {
            UserService.user.ugc_license = 1;
            UserService.user.$update();
          }

          self.currentCard.facts = self.currentFacts;
          self.currentCard.resource = 'generator';

          var card = angular.copy(self.currentCard);
          card.facts = self.currentFacts;
          card.resource = 'generator';

          var facts = [];
          // Make sure fact characters have the card_id set
          for (var x in card.facts) {
            if (card.facts[x] && card.facts[x].characters) {
              for (var y in card.facts[x].characters) {
                var character = card.facts[x].characters[y];
                if (character.type == 'character') {
                  character.card_id = card.card_id;
                  delete character.card_fact_character_id;
                }
              }
            }
            if (card.in_workflow) {
              facts.push(card.facts[x]);
            } else if (card.facts[x].entity_id === UserService.user.user_id) {
              facts.push(card.facts[x]);
            }
          }
          var characterPromises = [];
          var promises = facts.map(function (f) {
            var promise = Picmonics.generator(
              {
                card_id: card.card_id,
                resource: 'fact',
              },
              {
                fact_id: f.fact_id,
                entity_type_id: f.entity_type_id,
                display_name: f.display_name,
                picmonic: f.picmonic,
                definition: f.definition,
                hotspot_x: f.hotspot_x,
                hotspot_y: f.hotspot_y,
                is_primary: f.is_primary,
                is_private: f.is_private,
                indent: f.indent,
                prevent_zoom: f.prevent_zoom,
                tooltip_placement: f.tooltip_placement,
                tooltip_x: f.tooltip_x,
                tooltip_y: f.tooltip_y,
                order: f.order,
                classification_id: f.classification_id,
                user_fact_classification: f.user_fact_classification,
                header: f.header,
              }
            ).$promise;

            promise.then(function (fact) {
              f.fact_id = fact.fact_id;
              characterPromises.push(
                Picmonics.generator(
                  {
                    card_id: card.card_id,
                    resource: fact.id,
                    resource_id: 'characters',
                  },
                  {
                    characters: f.characters,
                  }
                ).$promise
              );
              Picmonics.generator(
                {
                  card_id: card.card_id,
                  resource: fact.id,
                  resource_id: 'quiz',
                },
                {
                  distractor_names: f.distractor_names,
                  question_text: f.question_text,
                  image_url: f.question_image_url,
                }
              );
            });

            return promise;
          });

          fp = $q.all(promises).then(function (facts) {
            var p1 = $q.all(characterPromises).then(function () {
              return Picmonics.generator(
                {
                  card_id: card.card_id,
                  resource: 'card',
                },
                {
                  background_id: card.background_id,
                  is_private: card.is_private,
                  is_mature: card.is_mature,
                  user_tracks: card.user_tracks,
                  overview: card.overview,
                  keywords: card.keywords,
                  transcripts: card.transcripts,
                  fact_ids: card.facts.map(function (f) {
                    return f.fact_id;
                  }),
                  facts_with_characters: card.facts.reduce(function (t, f) {
                    return t + !!f.characters.length;
                  }, 0),
                }
              ).$promise;
            });

            if (!card.in_workflow && card.entity_id !== UserService.user.user_id) {
              return $q.all([p1]);
            }

            var p2 = Picmonics.generator(
              {
                card_id: card.card_id,
                resource: 'audio',
              },
              {
                facts: card.facts.map(function (f) {
                  return {
                    fact_id: f.fact_id,
                    audio: f.audio,
                    new_audio_educational: f.new_audio_educational,
                    new_audio_story: f.new_audio_story,
                  };
                }),
                narrator: card.narrator,
                remove_audio: card.remove_audio,
              }
            ).$promise;

            return $q.all([p1, p2]);
          });

          return fp
            .then(function (r) {
              var data = r[0];
              LearnService.clearCardCache();

              if (data.entity_type_id == 1) {
                //Notify application that custom card has been updated
                $rootScope.$broadcast('myCardDataChanged', data);
              }

              // Reset the history before changing state to avoid unsaved change warnings
              self.resetHistory();
              if (self.returnTo) {
                if (self.returnTo == 'app.learn') {
                  $state.go('app.learn', {
                    slug: data.slug,
                    nomodal: true,
                  });
                } else {
                  $state.go(self.returnTo);
                }
              } else {
                return self
                  .getCard(data.slug)
                  .then(function (resolvedData) {
                    return self.init(resolvedData);
                  })
                  .finally(function () {
                    self.loading = false;
                  });
              }

              return r[0];
            })
            .catch(function () {})
            .finally(function () {
              self.loading = false;
            });
        }
      },

      removeUploadedAudio: function (type) {
        if (confirm('Are you sure you want to remove this audio?')) {
          if (!EditorService.currentCard.remove_audio) {
            EditorService.currentCard.remove_audio = {};
          }
          EditorService.currentCard.remove_audio[type] = 1;
          EditorService.currentCard[type + '_uploaded'] = 0;
          angular.forEach(EditorService.currentFacts, function (f) {
            delete f.audio[type].start;
          });
        }
      },

      setReturnTo: function (returnTo, afterFact) {
        var self = this;
        self.returnTo = returnTo;
        self.returnAfterFact = afterFact == true;
      },

      exportAsPsd: function () {
        var self = this;
        var promise = this.saveCard();
        promise.then(function () {
          window.location = '/api/v3/picmonics/' + self.currentCard.card_id + '/psd';
        });
      },

      hasFullPermission: function () {
        var self = this;
        return (
          (PermissionsService.hasAccess('admin', 'clone').result && self.currentCard.in_workflow) ||
          (self.currentCard.entity_id == UserService.user.user_id && self.currentCard.card_id >= 1000000)
        );
      },

      hasAccess: function (feature, permission, item) {
        var self = this;

        if (item && !self.currentCard.in_workflow) {
          if (
            item.entity_id == UserService.user.user_id &&
            (self.currentCard.card_id >= 1000000 || item.entity_type_id == 1)
          ) {
            return true;
          }
        }

        if (self.currentCard.in_workflow) {
          return self.hasFullPermission() ||
            (PermissionsService.hasAccess(feature, permission).result &&
              WorkflowService.hasOpenTask(UserService.user.user_id))
            ? true
            : false;
        } else {
          return self.currentCard.entity_id == UserService.user.user_id && self.currentCard.card_id >= 1000000;
        }
      },

      selectFact: function (fact) {
        var self = this;

        if (!self.hasAccess('workflow', 'fact_edit', fact)) {
          return;
        }

        self.clearSelectedFact();

        fact.selected = true;
        self.tmpFact = angular.copy(fact);
      },

      completeSelectedFact: function () {
        var self = this;
        self.addToHistory();
        if (
          !self.currentFact().header &&
          EditorService.subtab != 'question' &&
          !EditorService.currentCard.in_workflow
        ) {
          self.selectSubtab('question');
          if (typeof atlasEvent !== 'undefined') {
            atlasEvent('click', 'add_question');
          }
          return;
        } else {
          self.selectSubtab('fact');
        }
        // If we should return to something after editing this fact
        if (self.returnTo && self.returnAfterFact) {
          self.saveCard();
        } else {
          self.clearSelectedFact();
        }
      },

      cancelSelectedFact: function () {
        var self = this;
        self.selectSubtab('fact');
        // If we should return to something after editing this fact
        if (self.returnTo && self.returnAfterFact) {
          self.clearHistory();
          $state.go(self.returnTo, {
            slug: self.currentCard.slug,
          });
        } else {
          self.currentFacts.splice(self.currentFacts.indexOf(self.currentFact()), 1, self.tmpFact);
          self.clearSelectedFact();
        }
      },

      clearSelectedFact: function () {
        var self = this,
          selected;

        selected = self.currentFacts[$filter('arrayPos')(self.currentFacts, true, 'selected')];

        if (selected) {
          selected.selected = false;
        }

        self.clearSearch();
        self.characterUploadError = false;
        self.selectSubtab('fact');
      },

      selectCharacter: function (character) {
        var self = this;

        self.clearSelectedCharacter();

        character.selected = true;
      },

      clearSelectedCharacter: function () {
        var self = this,
          selected;

        for (var a in self.currentFacts) {
          for (var b in self.currentFacts[a].characters) {
            if (self.currentFacts[a].characters[b].selected) {
              selected = self.currentFacts[a].characters[b];
            }
          }
        }

        if (selected) {
          selected.selected = false;
        }
      },

      createNewFact: function (newFact) {
        var self = this;
        var name = '';
        var picmonic = '';
        var header = 0;

        if (typeof newFact == 'object') {
          name = newFact.name;
          picmonic = newFact.picmonic !== 'header' ? newFact.picmonic : '';
          header = newFact.header;
        } else {
          name = newFact;
        }

        var orderedFacts = $filter('filter')(self.currentFacts, {
          entity_type_id: self.hasAccess('workflow', 'fact_create', self.currentCard) ? 2 : 1,
        });
        var highestOrder = 0;

        if (orderedFacts.length) {
          for (var a in orderedFacts) {
            if (orderedFacts[a].order > highestOrder) {
              highestOrder = orderedFacts[a].order;
            }
          }
          highestOrder++;
        }

        self.currentFacts.push({
          display_name: name,
          name: name,
          picmonic: picmonic,
          entity_type_id: self.hasAccess('workflow', 'fact_create', self.currentCard) ? 2 : 1,
          entity_id: UserService.user.user_id,
          selected: header ? null : true,
          header: header ? header : 0,
          characters: [],
          is_primary: 0,
          is_private: self.hasAccess('workflow', 'fact_create', self.currentCard) ? 0 : 1,
          order: highestOrder,
          indent: 0,
        });

        self.setFactDisplayOrder();
        self.addToHistory();
      },

      updateSearch: function () {
        var self = this;
        if (self.imagesQuery != self.currentFact().picmonic && self.currentFact().picmonic != null) {
          self.imagesQuery = self.currentFact().picmonic;
          self.searchAssets('images', self.imagesQuery);
        }
      },

      uploadBackground: function (file, test) {
        var self = this;
        if (!file) {
          self.backgroundUploadError = true;
          return;
        }
        self.uploadingBackground = true;
        Upload.upload({
          url: '/api/v3/backgrounds',
          data: { background: file },
        }).then(
          function (resp) {
            self.selectBackground(resp.data);
            self.uploadingBackground = false;
            self.backgroundUploadError = false;
          },
          function (resp) {
            toaster.error(
              'An error was encountered while uploading your background. Try again, and if the problem persists, try another image.'
            );
            self.uploadingBackground = false;
            self.backgroundUploadError = true;
          }
        );
      },

      uploadQuizImage: function (file) {
        var self = this;
        if (!file) {
          return;
        }
        self.uploadingQuizImage = true;
        self.quizImageUploadError = '';
        Upload.upload({
          url: '/api/v3/user/upload',
          data: { file: file, type: 'quiz-image' },
        }).then(
          function (resp) {
            self.currentFact().question_image_url = resp.data.url;
            self.uploadingQuizImage = false;
          },
          function (resp) {
            self.quizImageUploadError = ' Whoops! There was an error uploading your image';
            self.uploadingQuizImage = false;
          }
        );
      },

      uploadCharacter: function (file, test) {
        var self = this;
        if (!file) {
          self.characterUploadError = true;
          return;
        }
        self.uploadingCharacter = true;
        Upload.upload({
          url: '/api/v2/characters',
          data: { character: file },
        }).then(
          function (resp) {
            self.addCharacter(resp.data);
            self.uploadingCharacter = false;
            self.characterUploadError = false;
          },
          function (resp) {
            self.uploadingCharacter = false;
            self.characterUploadError = true;
          }
        );
      },

      moveFact: function (fact, replace) {
        var self = this;
        var tempFact, a;
        var facts = $filter('filter')(self.currentFacts, {
          entity_type_id: fact.entity_type_id,
          is_primary: '!1',
        });
        var position = replace.order;

        if (!self.hasAccess('workflow', 'fact_reorder', fact)) return;

        if (position > fact.order) {
          for (a in facts) {
            tempFact = facts[a];

            if (tempFact.order <= position && tempFact.order > fact.order) {
              tempFact.order--;
            }
          }
        } else if (position < fact.order) {
          for (a in facts) {
            tempFact = facts[a];

            if (tempFact.order >= position && tempFact.order < fact.order) {
              tempFact.order++;
            }
          }
        }

        fact.order = position;

        self.setFactDisplayOrder();
        self.addToHistory();
      },

      deleteFact: function (fact) {
        var self = this;
        if (!fact) {
          fact = self.currentFact();
        }

        if (
          (fact.header && self.hasAccess('workflow', 'header_delete', fact)) ||
          (!fact.header && self.hasAccess('workflow', 'fact_delete', fact))
        ) {
          function deleteFact() {
            self.currentFacts.splice(self.currentFacts.indexOf(fact), 1);
            self.clearSelectedFact();
            self.setFactDisplayOrder();
            self.addToHistory();
          }

          $modal.open({
            templateUrl: '/templates/modals/delete-confirm.html',
            windowClass: 'below-nav learn-master-complete',
            backdropClass: 'below-nav',
            size: 'sm',
            controller: [
              '$scope',
              '$modalInstance',
              '$document',
              function ($scope, $modalInstance, $document) {
                $scope.confirmation_text =
                  'Are you sure you want to delete this ' + (fact.header ? 'header' : 'fact') + '?';

                $scope.confirm = function () {
                  deleteFact();
                  $scope.cancel();
                };

                function onKeydown(event) {
                  if (event.keyCode === 13) {
                    event.preventDefault();
                    $scope.confirm();
                  }
                }

                $document.on('keydown', onKeydown);
                $scope.$on('$destroy', function () {
                  $document.off('keydown', onKeydown);
                });

                $scope.cancel = function () {
                  $modalInstance.close();
                };
              },
            ],
          });
        }
      },

      clearSearch: function (refreshBackgrounds) {
        var self = this;

        self.backgroundsSearchResults = [];
        self.imagesSearchResults = [];
        self.backgroundsQuery = '';
        self.imagesQuery = '';
        self.backgroundsPagination = {};
        self.imagesPagination = {};

        if (refreshBackgrounds) {
          self.searchAssets('backgrounds', '');
        }
      },

      searchAssets: function (type, query, page) {
        var self = this;
        var request;
        if (!self.seed) {
          self.seed = Math.floor(Math.random() * 10000);
        }
        if (!self[type + 'Loading']) {
          self[type + 'Loading'] = true;
          if (self[type + 'Pagination'].query == (query ? query : self[type + 'Query'])) {
            if (!page) {
              self[type + 'Loading'] = false;
              return;
            }

            request = {
              query: query ? query : self[type + 'Query'],
              page: page,
              seed: self.seed,
            };
          } else {
            self[type + 'SearchResults'] = [];

            request = {
              query: query ? query : self[type + 'Query'],
              seed: self.seed,
            };
          }

          // Reset on empty query
          if (type != 'backgrounds' && !request.query) {
            self[type + 'SearchResults'] = {};
            self[type + 'Pagination'] = {
              query: '',
              current_page: 1,
              last_page: 1,
              total: 0,
            };
            self[type + 'Loading'] = false;
            return;
          }

          resourceType = type === 'images' ? self.imagesSearchSubType : type;

          HALResource.search[resourceType](request)
            .$promise.then(function (result) {
              self[type + 'Pagination'] = {
                query: query ? query : self[type + 'Query'],
                current_page: result.current_page ? result.current_page : page ? page : 1,
                last_page: result.last_page
                  ? result.last_page
                  : result.data.length
                  ? 10000
                  : self[type + 'SearchResults'].length / 25,
                total: result.total ? result.total : result.data.length ? 10000 : self[type + 'SearchResults'].length,
              };

              // Sorry, Jullian -- Couldn't get the .data to come back as an array :'(
              if (type == 'images') {
                for (var x in result.data) {
                  if (result.data.hasOwnProperty(x) && result.data[x].assets) {
                    self[type + 'SearchResults'].push(result.data[x]);
                  }
                }
              } else {
                self[type + 'SearchResults'] = self[type + 'SearchResults'].concat(result.data);
              }
            })
            .finally(function () {
              self[type + 'Loading'] = false;

              if (type === 'backgrounds') {
                self.backgroundScrollCheckOn();
              }
            });
        }
      },

      nextAssetSearchPage: function (type) {
        var self = this;
        if (self[type + 'Pagination'].current_page + 1 > self[type + 'Pagination'].last_page) return;

        self.searchAssets(type, self[type + 'Pagination'].query, self[type + 'Pagination'].current_page + 1);
      },

      removeBrokenBackground: function (background) {
        var self = this;
        if (!self.hasAccess('workflow', 'background', self.currentCard)) {
          return false;
        }
        var ev = false;
        // Remove the background from the searchResults
        self.backgroundsSearchResults.splice(self.backgroundsSearchResults.indexOf(background), 1);
        // Fire a click event to force angular to respect the change
        if (document.createEvent) {
          ev = document.createEvent('Event');
          ev.initEvent('click', true, false);
          document.body.dispatchEvent(ev);
        } else {
          ev = document.createEventObject();
          ev.eventType = 'click';
          document.body.fireEvent('onclick', ev);
        }
      },

      resizeAsset: function (url, size) {
        if (!url) {
          return '';
        }
        return url.replace('picmonic_assets', 'picmonic_assets' + this.getSizeSuffix(size));
      },

      selectBackground: function (background) {
        var self = this;
        if (self.backgroundLoading || self.backgroundsLoading) {
          return;
        }
        if (!this.hasAccess('workflow', 'background', self.currentCard)) {
          return false;
        }

        // Resize the background image
        if (background) {
          if (background.background_id != self.currentCard.background_id) {
            background.loading = true;

            var img = new Image();
            self.backgroundLoading = true;

            img.addEventListener('load', function () {
              $rootScope.$apply(function () {
                background.loading = false;
                self.backgroundLoading = false;
              });
            });

            img.addEventListener('error', function () {
              $rootScope.$apply(function () {
                background.loading = false;
                self.backgroundLoading = false;
              });
            });

            img.src = background.image_url;

            self.currentCard.background_id = background.background_id || background.id;
            self.currentCard.background_image_url = background.image_url;
            self.addToHistory();
          }
        }
      },

      getSizeSuffix: function (size) {
        var sizeSuffix;
        switch (size) {
          case 'md':
            sizeSuffix = '_threequarter';
            break;
          case 'sm':
            sizeSuffix = '_half';
            break;
          case 'xs':
            sizeSuffix = '_quarter';
            break;
        }
        return sizeSuffix;
      },

      addCharacter: function (character, index, data) {
        var self = this;
        var char = angular.copy(character);
        var currentFact = self.tab == 'topic' ? self.primaryFact() : self.currentFact();

        // Max width & height
        var max_width = 2200 * 0.5;
        var max_height = 1700 * 0.5;

        // Set new character's dimensions, x and y coordinates
        char.character_width = (char.original_width > max_width ? max_width : char.original_width) * 1;
        char.character_height = (char.original_height > max_height ? max_height : char.original_height) * 1;
        char.character_x = (2200 - char.character_width) / 2;
        char.character_y = (1700 - char.character_height) / 2;
        char.card_id = self.currentCard.card_id * 1;
        char.crop_x = 0;
        char.crop_y = 0;
        char.crop_width = char.character_width;
        char.crop_height = char.character_height;

        // Determine new character's z-index
        var highestz = 0;

        var facts = self.currentFacts;

        for (var b in facts) {
          for (var c in facts[b].characters) {
            if (!facts[b].characters[c].deleted) {
              if (facts[b].characters[c].character_z) {
                highestz =
                  facts[b].characters[c].character_z > highestz ? facts[b].characters[c].character_z : highestz;
              }
              for (var d in facts[b].characters[c].assets) {
                highestz =
                  facts[b].characters[c].assets[d].z > highestz ? facts[b].characters[c].assets[d].z : highestz;
              }
            }
          }
        }

        char.character_z = highestz + 1;

        // Determine if the hotspot goes into the new character
        var remainingCharacters = $filter('filter')(currentFact.characters, {
          deleted: '!true',
        });

        if (!remainingCharacters.length) {
          currentFact.hotspot_x = char.character_x + char.character_width / 2;
          currentFact.hotspot_y = char.character_y + char.character_height / 2;
        }

        char.animation = self.currentFact().animation
          ? self.currentFact().animation + ' ' + self.currentFact().animation_speed
          : null;

        // Add new character to fact array, then update action & search history
        if (data) {
          delete char.hal;
          var asset = char.assets[0];
          var canvas = new fabric.Canvas('google');
          canvas.width = asset.width;
          canvas.height = asset.height;
          fabric.Image.fromURL(asset.image_url, function (i) {
            $rootScope.$apply(function () {
              canvas.add(i);
              var url = canvas.toDataURL();
              char.image_data = url;
              var img = new Image();
              img.style.top = '0%';
              img.style.left = '0%';
              img.style.height = '100%';
              img.style.width = '100%';
              img.src = url;
              char.assets = [
                {
                  height: asset.height,
                  width: asset.width,
                  x: 0,
                  y: 0,
                  z: 1,
                  img: img,
                },
              ];
              currentFact.characters.push(char);
              self.selectCharacter(char);
              self.addToHistory();
            });
          });
          return;
        }

        currentFact.characters.push(char);
        self.selectCharacter(char);
        self.addToHistory();
        var action;
        var result_position;
        var resource_id;
        var resource_type;

        if (character.hal) {
          action = 'select_image';
          resource_id = character.assets[0].id;
          result_position = index;
          resource_type = 'image';
        } else {
          action = 'select_character';
          resource_id = character.character_id;
          result_position = index;
          resource_type = 'character';
        }

        HALResource.search.selectImage({
          query: EditorService.imagesQuery,
          user_id: UserService.user.user_id,
          resource_id: resource_id,
          result_position: result_position,
          resource_type: resource_type,
          action: action,
        });
      },

      addToHistory: function () {
        var self = this;
        self.history.push({
          currentCard: angular.copy(self.currentCard),
          currentFacts: angular.copy(self.currentFacts),
        });
      },

      undo: function () {
        var self = this;

        if (self.history.length > 1) {
          self.history.pop();

          var last = self.history[self.history.length - 1];

          for (var a in last) {
            self[a] = angular.copy(last[a]);
          }
        }
      },

      //Clear History
      //completely erase the history
      clearHistory: function () {
        var self = this;
        self.history = [];
      },

      //Reset History
      //reset the history array so that the only entry is the most recent state (the new default state)
      resetHistory: function () {
        var self = this;
        self.history = [];
        self.addToHistory();
      },

      showAddHeadersModal: function () {
        var self = this;
        $modal.open({
          templateUrl: '/templates/modals/add-headers.html',
          windowClass: 'below-nav learn-master-complete',
          backdropClass: 'below-nav ',
          size: 'lg',
          controller: [
            '$scope',
            'TopicTypesResource',
            'adminPicmonics',
            function ($scope, TopicTypesResource, adminPicmonics) {
              $scope.card = self.currentCard;
              $scope.topic_types = TopicTypesResource.query();
              $scope.topic_type_id = $scope.card.topic_type_id;
              $scope.loading = false;

              $scope.addHeaders = function () {
                $scope.loading = true;
                adminPicmonics.addHeaders(
                  {
                    id: $scope.card.card_id,
                    topic_type_id: $scope.topic_type_id,
                  },
                  function () {
                    Picmonics.query(
                      {
                        card_id: $scope.card.card_id,
                        resource: 'facts',
                      },
                      function (facts) {
                        self.userFacts = $filter('filter')(facts, {
                          entity_type_id: '1',
                        });
                        self.currentFacts = $filter('orderBy')(
                          $filter('filter')(facts, {
                            entity_type_id: '!1',
                          }),
                          ['order', 'fact_id']
                        );
                        self.setFactDisplayOrder();

                        $scope.loading = false;
                        $scope.$close();
                      }
                    );
                  }
                );
              };

              $scope.cancel = function () {
                $scope.$dismiss();
              };
            },
          ],
        });
      },

      setFactDisplayOrder: function () {
        var self = this;
        var facts = $filter('orderBy')(self.currentFacts, ['-is_primary', 'order']);

        var count = 0;

        for (var a in facts) {
          if (!facts[a].header && facts[a].entity_type_id != 1) {
            facts[a].display_order = count;
            facts[a].new_audio = facts[a].new_audio || [];
            count++;
            if (facts[a].characters) {
              for (var b in facts[a].characters) {
                if (facts[a].characters[b].animation) {
                  var parts = facts[a].characters[b].animation.split(' ');
                  facts[a].characters[b].animation_type = parts[0];
                  facts[a].characters[b].animation_speed = parts[1];
                }
              }
            }
          }
        }
      },

      toggleSummary: function () {
        var self = this;
        self.summaryOpen = !self.summaryOpen;
      },

      toggleComments: function () {
        var self = this;
        self.showComments = !self.showComments;
        if (self.showComments) {
          self.rightSidebarOpen = true;
          self.rightSidebarTab = 'comments';
        }
      },

      selectTab: function (tab) {
        var self = this;
        self.addToHistory();
        if (
          tab == self.tab &&
          (tab != 'fact' || (tab == 'fact' && !self.currentFact())) &&
          (tab != 'audio' || (tab == 'audio' && !self.currentFact()))
        ) {
          return;
        }

        self.clearSelectedFact();
        self.clearSearch();

        if (tab == 'background') {
          if (!self.backgroundsSearchResults.length) {
            self.searchAssets('backgrounds', '');
          }
        } else {
          self.backgroundScrollCheckOff();
        }

        if (tab == 'audio') {
          self.subtab = 'narrate';
          if (typeof atlasEvent !== 'undefined') {
            atlasEvent('click', 'add_narration');
          }
        }

        if (tab === 'fact') {
          if (!UserService.user.has_seen.my_fact) {
            $modal.open({
              templateUrl: '/templates/modals/my-fact.html',
              windowClass: 'editor-modal',
              backdrop: 'static',
              size: 'md',
              controller: [
                '$scope',
                'UserService',
                function ($scope, UserService) {
                  $scope.dontShow = 0;
                  $scope.saveDoNotShowNotification = function () {
                    if ($scope.dontShow) {
                      UserService.see('my_fact');
                    }
                    $scope.$close();
                  };
                },
              ],
            });
          }
        }

        self.tab = tab;

        $timeout(function () {
          switch (tab) {
            case 'topic':
              angular.element('.topic-name-input input').focus();
              break;
            case 'background':
              angular.element('.backgrounds-input').focus();
              break;
          }
        }, 0);
      },

      selectSubtab: function (subtab) {
        var self = this;

        self.subtab = subtab;

        $timeout(function () {
          switch (subtab) {
            case 'fact':
              angular.element('.fact-name-input input').focus();
              break;
            case 'question':
              angular.element('.fact-definition-input').focus();
              self.getSuggestedDistractors();
              break;
          }
        }, 0);
      },

      getSuggestedDistractors: function () {
        var self = this;
        var fact = self.currentFact();
        self.suggestedDistractors = FactsResource.queryv3({
          name: fact.display_name || fact.name,
          classification_id: fact.classification_id,
          track_ids: self.currentCard.user_tracks
            .map(function (item) {
              return item.track_id;
            })
            .join(','),
          type: 'suggested_distractors',
        });
      },

      filterSuggestedDistractors: function (distractor) {
        var self = EditorService;
        var fact = self.currentFact();
        if (
          distractor.display_name === fact.name ||
          (fact.distractor_names && fact.distractor_names.indexOf(distractor.display_name) > -1)
        ) {
          return false;
        }

        return true;
      },

      addRandomSuggestedDistractors: function () {
        var self = EditorService;
        var d = $filter('filter')(self.suggestedDistractors, self.filterSuggestedDistractors);
        d = d
          .sort(function () {
            return Math.random() - 0.5;
          })
          .slice(0, 10);
        angular.forEach(d, self.addDistractor);
      },

      addDistractor: function ($item) {
        var name = typeof $item === 'object' ? $item.display_name : $item;
        var fact = EditorService.currentFact();
        fact.createDistractor = '';
        if (fact.display_name === name) {
          return;
        }
        if (fact.distractor_names) {
          if (fact.distractor_names.indexOf(name) > -1) {
            return;
          }
          fact.distractor_names.push(name);
        } else {
          fact.distractor_names = [name];
        }
      },

      verifyAndLearn: function () {
        var self = this;

        // Show modal
        $modal.open({
          templateUrl: '/templates/modals/editor-completion-verification.html',
          windowClass: 'below-nav editor-modal',
          backdropClass: 'below-nav',
          size: 'md',
          controller: [
            '$scope',
            '$modalInstance',
            '$state',
            '$timeout',
            'UserService',
            function ($scope, $modalInstance, $state, $timeout, UserService) {
              $scope.EditorService = self;
              $scope.UserService = UserService;
              $scope.saving = false;

              $scope.save = function (publish) {
                $scope.publish = publish;

                if (publish && !$scope.can_publish) {
                  return;
                }

                if (publish) {
                  // purposely use different loading variable to make animation smoother when closing the modal
                  $scope.saving = true;
                }

                EditorService.currentCard.is_private = publish ? 0 : 1;

                self.saveCard().then(
                  function () {
                    $modalInstance.close();
                    EditorService.complete();
                    console.log('done');
                  },
                  function () {
                    $scope.saving = false;
                  }
                );
              };

              $scope.showAudioTab = function (fact) {
                $modalInstance.close();
                EditorService.selectTab('audio');
                EditorService.selectFact(fact);
              };

              $scope.showBackgroundTab = function () {
                $modalInstance.close();
                EditorService.selectTab('background');
              };

              $scope.showCategoryTab = function () {
                $modalInstance.close();
                EditorService.selectTab('category');
              };

              $scope.showFactsTab = function (fact, field) {
                $modalInstance.close();

                if (fact && fact.is_primary) {
                  EditorService.selectTab('topic');

                  $timeout(function () {
                    switch (field) {
                      case 'name':
                        angular.element('.fact-name').focus();
                        break;
                      case 'definition':
                        angular.element('.picmonic-definition').focus();
                        break;
                      case 'character-name':
                        angular.element('.picmonic-title').focus();
                        break;
                      case 'character-image':
                        angular.element('.topic-character-input').focus();
                        break;
                    }
                  }, 0);
                } else {
                  EditorService.selectTab('fact');

                  if (fact) {
                    EditorService.selectFact(fact);
                    EditorService.selectSubtab('fact');
                  }

                  if (field === 'quiz-question') {
                    EditorService.selectSubtab('question');
                  }

                  $timeout(function () {
                    switch (field) {
                      case 'name':
                        angular.element('.fact-name').focus();
                        break;
                      case 'definition':
                        angular.element('.fact-definition-input').focus();
                        break;
                      case 'character-name':
                        angular.element('.character-name-input').focus();
                        break;
                      case 'character-image':
                        angular.element('.character-search-input').focus();
                        break;
                      case 'quiz-question':
                        angular.element('.fact-definition-input').focus();
                        break;
                    }
                  }, 0);
                }
              };

              $scope.totalFacts = self.currentFacts.length;
              $scope.facts_without_names = [];
              $scope.facts_without_character_names = [];
              $scope.facts_without_character_images = [];
              $scope.facts_without_quiz_questions = [];
              $scope.facts_without_definitions = [];
              $scope.facts_without_audio = [];

              if ($scope.totalFacts > 0) {
                angular.forEach(self.currentFacts, function (fact) {
                  if (fact.header || fact.entity_id !== UserService.user.user_id) {
                    return;
                  }

                  if (!fact.name) {
                    $scope.facts_without_names.push(fact);
                  }

                  if (!fact.picmonic) {
                    $scope.facts_without_character_names.push(fact);
                  }

                  if (!fact.characters.length) {
                    $scope.facts_without_character_images.push(fact);
                  }

                  if (!fact.definition) {
                    $scope.facts_without_definitions.push(fact);
                  }

                  if (!fact.question_text && !fact.is_primary) {
                    $scope.facts_without_quiz_questions.push(fact);
                  }
                  if (
                    !EditorService.audioLoaded &&
                    !fact.new_audio['educational'] &&
                    (!fact.audio ||
                      !fact.audio.educational ||
                      (!fact.audio.educational.story &&
                        !fact.audio.educational.fact_audio_url &&
                        fact.audio.educational.start === undefined))
                  ) {
                    $scope.facts_without_audio.push(fact);
                  }
                });
              }

              $scope.rules = [
                {
                  name: '2+ facts each with a name, character name, and image',
                  value:
                    $scope.totalFacts >= 2 &&
                    $scope.facts_without_names.length === 0 &&
                    $scope.facts_without_character_names.length === 0 &&
                    $scope.facts_without_character_images.length === 0,
                  required: UserService.user.creator_community_access ? false : true,
                  handler: function () {
                    if ($scope.facts_without_names.length) {
                      return $scope.showFactsTab($scope.facts_without_names[0], 'name');
                    }

                    if ($scope.facts_without_character_names.length) {
                      return $scope.showFactsTab($scope.facts_without_character_names[0], 'character-name');
                    }

                    if ($scope.facts_without_character_images.length) {
                      return $scope.showFactsTab($scope.facts_without_character_images[0], 'character-image');
                    }

                    if ($scope.totalFacts < 2) {
                      return $scope.showFactsTab();
                    }
                  },
                },
                {
                  name: 'A background image',
                  value: !!self.currentCard.background_id,
                  required: UserService.user.creator_community_access ? false : true,
                  handler: $scope.showBackgroundTab,
                },
                {
                  name: 'Audio for all facts',
                  value: $scope.facts_without_audio.length === 0,
                  required: false,
                  handler: function () {
                    if ($scope.facts_without_audio.length) {
                      return $scope.showAudioTab($scope.facts_without_audio[0]);
                    }
                  },
                },
                {
                  name: 'Quiz questions for all facts',
                  value: $scope.totalFacts >= 2 && $scope.facts_without_quiz_questions.length === 0,
                  required: false,
                  handler: function () {
                    if ($scope.facts_without_quiz_questions.length) {
                      return $scope.showFactsTab($scope.facts_without_quiz_questions[0], 'quiz-question');
                    }
                  },
                },
                {
                  name: 'Definitions for all facts',
                  value: $scope.facts_without_definitions.length === 0,
                  required: false,
                  handler: function () {
                    if ($scope.facts_without_definitions.length) {
                      return $scope.showFactsTab($scope.facts_without_definitions[0], 'definition');
                    }
                  },
                },
                {
                  name: 'Topic categorized',
                  value: !!self.currentCard.user_tracks.length,
                  required: false,
                  handler: function () {
                    if (!self.currentCard.user_tracks.length) {
                      return $scope.showCategoryTab();
                    }
                  },
                },
              ];

              $scope.can_publish = $filter('filter')($scope.rules, { required: true, value: false }, true).length === 0;
            },
          ],
        });
      },

      recordAudio: function () {
        AudioService.record();
      },

      stopRecordingAudio: function () {
        var self = this;
        return $q(function (resolve, reject) {
          AudioService.stop().then(function (blob) {
            var reader = new window.FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = function () {
              var base64data = reader.result;

              $rootScope.$apply(function () {
                self.currentFact().new_audio[self.audioType] = base64data;
                self.currentFact()['new_audio_' + self.audioType] = base64data;
                self.addToHistory();
              });
              resolve();
            };
          });
        });
      },

      complete: function () {
        $state.go('app.learn', {
          slug: EditorService.currentCard.slug,
        });
      },

      nextTab: function () {
        var self = this;

        self.selectTab(
          angular
            .element(angular.element('#' + self.tab + '-tab').nextAll('.editor-tab[id*="-tab"]')[0])
            .attr('id')
            .replace('-tab', '')
        );
      },

      previousTab: function () {
        var self = this;

        self.selectTab(
          angular
            .element(angular.element('#' + self.tab + '-tab').prevAll('.editor-tab[id*="-tab"]')[0])
            .attr('id')
            .replace('-tab', '')
        );
      },

      doneEditing: function () {
        var self = this;

        if (self.currentCard.entity_type_id == 2 || self.currentCard.entity_id != UserService.user.user_id) {
          self.saveCard().then(function () {
            $state.go('app.learn', {
              slug: self.currentCard.slug,
              nomodal: true,
            });
          });
        } else {
          self.verifyAndLearn();
        }
      },

      close: function () {
        var self = this;
        $state.go('app.learn', {
          slug: self.currentCard.slug,
          nomodal: true,
        });
      },

      refresh: function () {
        var self = this;

        self.loading = true;
        var promise = self.getCard(self.currentCard.slug);

        promise
          .then(function (resolvedData) {
            self.init(resolvedData);
          })
          .finally(function () {
            self.loading = false;
          });

        return promise;
      },

      init: function (resolvedData) {
        var self = this;
        self.currentCard = resolvedData.currentCard;
        self.currentCard.narrator = self.currentCard.narrator || 'Brian';
        self.currentFacts = $filter('orderBy')(resolvedData.currentFacts, ['order', 'fact_id']);
        self.setFactDisplayOrder();
        self.clearHistory();
        $rootScope.$emit('endInteraction');

        self.showAlternateImageSources = true;
      },

      reset: function () {
        var self = this;
        angular.merge(self, defaults);
      },

      isEqual: function (a, b) {
        return _.isEqual(angular.copy(a), angular.copy(b));
      },

      // Toggle HAL on/off & optionally set the target
      halToggle: function () {
        this.halOpen = !this.halOpen;
        if (this.halOpen) {
          this.halTarget = this.currentFact();
        }
      },

      halComplete: function ($character) {
        // Update the blue-word
        this.halTarget.picmonic = $character.name;

        // Add the character
        $character.hal = true;
        this.addCharacter($character, 0);

        // Hide the generator
        this.halOpen = false;
        this.halTarget = false;
      },

      getSlowSpeedMode: function () {
        return 0;
      },

      recordedCount: function () {
        var self = this;
        var count = 0;
        angular.forEach(this.currentFacts, function (fact) {
          if (
            !fact.header &&
            fact.entity_type_id == 2 &&
            (fact.new_audio[self.audioType] ||
              (fact.audio && fact.audio[self.audioType] && fact.audio[self.audioType].fact_audio_url))
          ) {
            count++;
          }
        });
        return count;
      },

      storyCount: function () {
        var self = this;
        var count = 0;
        angular.forEach(this.currentFacts, function (fact) {
          if (
            !fact.header &&
            fact.entity_type_id == 2 &&
            fact.audio &&
            fact.audio[self.audioType] &&
            fact.audio[self.audioType].story
          ) {
            count++;
          }
        });
        return count;
      },

      categorize: function (admin) {
        var self = this;

        $modal.open({
          templateUrl: '/templates/modals/categorize-topic.html',
          controller: [
            '$scope',
            '$filter',
            'Pathways',
            'Tracks',
            'MarketOptionsConfig',
            function ($scope, $filter, Pathways, Tracks, MarketOptionsConfig) {
              $scope.MarketOptionsConfig = MarketOptionsConfig;
              $scope.market_id = UserService.user.lead;
              $scope.admin = admin;

              $scope.getSections = function () {
                $scope.sections = Pathways.getv3({
                  market_id: $scope.market_id,
                  visible_in_categorization: 1,
                  card_id: self.currentCard.card_id,
                });
              };

              $scope.getTracks = function (pathway) {
                if (pathway.tracks) {
                  return;
                }
                pathway.tracks = Pathways.queryv3({
                  pathway_id: pathway.pathway_id,
                  resource: 'tracks',
                  show_hidden: admin ? 1 : 0,
                  visible_in_categorization: 1,
                  card_id: self.currentCard.card_id,
                });
              };

              $scope.selectTrack = function (track, furpath, subpath, pathway, section_name) {
                if (admin) {
                  if ($scope.savingCards) {
                    return;
                  }

                  if (!confirm('Adding this card will also add it to this market. Are you sure?')) {
                    return;
                  }

                  $scope.savingCards = true;

                  Tracks.savev2(
                    {
                      track_id: track.track_id,
                      resource: 'picmonics',
                      card_id: self.currentCard.card_id,
                      sort_order: track.total,
                      market_id: $scope.market_id,
                    },
                    function () {
                      $scope.savingCards = false;
                      track.total += 1;
                      self.currentCard.tracks.push({
                        track_id: track.track_id,
                        breadcrumb:
                          MarketOptionsConfig.getMarketById(pathway.market_id).name +
                          ' / ' +
                          section_name +
                          ' / ' +
                          pathway.name +
                          ' / ' +
                          subpath.name +
                          ' / ' +
                          (furpath ? furpath.name + ' / ' : '') +
                          track.name,
                      });
                    },
                    function (response) {
                      $scope.error = response.data.error;
                      $scope.savingCards = false;
                    }
                  );
                } else {
                  self.currentCard.user_tracks.push({
                    track_id: track.track_id,
                    breadcrumb:
                      section_name +
                      ' / ' +
                      pathway.name +
                      ' / ' +
                      subpath.name +
                      ' / ' +
                      (furpath ? furpath.name + ' / ' : '') +
                      track.name,
                  });
                }
              };

              $scope.removeCategory = function (track) {
                if (admin) {
                  if ($scope.savingCards) {
                    return;
                  }

                  $scope.savingCards = true;

                  Tracks.deletev2({
                    track_id: track.track_id,
                    resource: 'picmonics',
                    resource_id: self.currentCard.card_id,
                  }).$promise.then(function () {
                    self.currentCard.tracks.splice(
                      self.currentCard.tracks.indexOf(
                        $filter('filter')(
                          self.currentCard.tracks,
                          {
                            track_id: track.track_id,
                          },
                          true
                        )[0]
                      ),
                      1
                    );

                    $scope.savingCards = false;

                    track.total -= 1;
                  });
                } else {
                  self.currentCard.user_tracks.splice(
                    self.currentCard.user_tracks.indexOf(
                      $filter('filter')(self.currentCard.user_tracks, { track_id: track.track_id }, true)[0]
                    ),
                    1
                  );
                }
              };

              $scope.trackExists = function (track) {
                if (admin) {
                  return !!$filter('filter')(self.currentCard.tracks, { track_id: track.track_id }, true).length;
                } else {
                  return !!$filter('filter')(self.currentCard.user_tracks, { track_id: track.track_id }, true).length;
                }
              };

              $scope.openTrackInAdmin = function (track, furpath, subpath, pathway, section_name) {
                window.open('/adminv2/pathways/' + pathway.pathway_id + '/tracks/' + track.track_id, '_blank');
              };

              $scope.togglePathwayVisibility = function (pathway) {
                pathway.hidden = !pathway.hidden ? 1 : 0;
                Pathways.update(pathway);
              };

              $scope.toggleTrackVisibility = function (track) {
                track.hidden = !track.hidden ? 1 : 0;
                Tracks.update(track);
              };

              $scope.getSections();
            },
          ],
        });
      },

      removeCategory: function (track) {
        this.currentCard.user_tracks.splice(this.currentCard.user_tracks.indexOf(track), 1);
      },

      removeCategoryAdmin: function (track) {
        var self = this;

        Tracks.deletev2({
          track_id: track.track_id,
          resource: 'picmonics',
          resource_id: self.currentCard.card_id,
        }).$promise.then(function () {
          self.currentCard.tracks.splice(
            self.currentCard.tracks.indexOf(
              $filter('filter')(self.currentCard.tracks, { track_id: track.track_id }, true)[0]
            ),
            1
          );

          track.total -= 1;
        });
      },

      backgroundScrollCheck: false,

      backgroundScrollCheckOff: function () {
        var self = this;

        if (self.backgroundScrollCheck) {
          self.backgroundScrollCheck = false;
          angular.element('.player-sidebar-wrapper__content').off('scroll', self.checkIfBottomOfBackgrounds);
        }
      },

      backgroundScrollCheckOn: function () {
        var self = this;

        if (!self.backgroundScrollCheck) {
          self.backgroundScrollCheck = true;
          angular.element('.player-sidebar-wrapper__content').on('scroll', self.checkIfBottomOfBackgrounds);
        }
      },

      checkIfBottomOfBackgrounds: function (e) {
        var element = angular.element('.player-sidebar-wrapper__content')[0];
        if (element.scrollTop > element.scrollHeight - element.offsetHeight - 400) {
          EditorService.backgroundScrollCheckOff();
          EditorService.nextAssetSearchPage('backgrounds');
        }
      },

      previewAnimation: function (character) {
        character.animation = null;

        $timeout(function () {
          character.animation = character.animation_type
            ? character.animation_type + ' ' + character.animation_speed
            : null;
          character.allow_animation = 1;
        }, 0);
      },
      updateCharacterAnimations: function (character) {
        var self = this;
        if (!character.animation_speed) {
          character.animation_speed = 'm';
        }

        character.animation = character.animation_type + ' ' + character.animation_speed;
      },
      showTextCreator: function (prevChar) {
        var self = this;
        $modal.open({
          templateUrl: '/templates/modals/add-text-label.html',
          controller: [
            '$scope',
            function ($scope) {
              $scope.sizes = [8, 10, 12, 14, 16, 18, 20, 24, 28, 32, 36, 40, 48, 52, 64];
              $scope.fonts = [
                'Arial',
                'Arial Black',
                'Bookman',
                'Candara',
                'Comic Sans MS',
                'Courier',
                'Courier New',
                'Garamond',
                'Georgia',
                'Impact',
                'Palatino',
                'Roboto',
                'Times',
                'Times New Roman',
                'Verdana',
              ];
              if (prevChar) {
                var options = (
                  prevChar.name.indexOf('.png') > -1
                    ? prevChar.name.substring(0, prevChar.name.length - 4)
                    : prevChar.name
                ).split('_');
                $scope.label = options[1];
                $scope.font = options[2];
                $scope.size = Number(options[3]);
                $scope.color = options[4];
              } else {
                $scope.size = 36;
                $scope.color = 'black';
                $scope.font = 'Arial';
              }

              $scope.add = function () {
                var text = new fabric.Text($scope.label, {
                  fontFamily: $scope.font,
                  fontSize: $scope.size * 4,
                  fill: $scope.color,
                  lineHeight: 1,
                });
                var canvas = document.createElement('CANVAS');
                canvas.width = text.width;
                canvas.height = text.height;
                var textCanvas = new fabric.Canvas(canvas);

                textCanvas.add(text);

                var canvas1 = textCanvas.toCanvasElement();
                var img = new Image();
                img.src = canvas1.toDataURL();
                img.style.width = '100%';
                img.style.height = '100%';

                var currentFact = self.tab == 'topic' ? self.primaryFact() : self.currentFact();

                if (prevChar) {
                  char = angular.copy(prevChar);

                  if (prevChar.card_fact_character_id) {
                    prevChar.deleted = true;
                  } else {
                    currentFact.characters.splice(currentFact.characters.indexOf(prevChar));
                  }
                  delete char.card_fact_character_id;
                } else {
                  var char = {};
                }

                char.image_data = canvas1.toDataURL();
                char.name = 'plstext_' + $scope.label + '_' + $scope.font + '_' + $scope.size + '_' + $scope.color;

                char.assets = [
                  {
                    img: img,
                    x: 0,
                    y: 0,
                  },
                ];
                var container = $('.learn-image-wrapper');
                var learncontainerstyles = getComputedStyle(container[0]);
                var learncontainer = {
                  width: parseFloat(learncontainerstyles.width),
                  height: parseFloat(learncontainerstyles.height),
                };
                var scale = {
                  x: learncontainer.width / 2200,
                  y: learncontainer.height / 1700,
                };

                // Set new character's dimensions, x and y coordinates
                char.character_width = text.width / 4 / scale.x;
                char.character_height = text.height / 4 / scale.y;
                char.character_x = char.character_x || (2200 - char.character_width) / 2;
                char.character_y = char.character_y || (1700 - char.character_height) / 2;
                char.card_id = self.currentCard.card_id * 1;
                char.crop_x = 0;
                char.crop_y = 0;
                char.crop_width = char.character_width;
                char.crop_height = char.character_height;
                char.original_width = text.width;
                char.original_height = text.height;

                // Determine new character's z-index
                var highestz = 0;

                var facts = self.currentFacts;

                for (var b in facts) {
                  for (var c in facts[b].characters) {
                    if (!facts[b].characters[c].deleted) {
                      if (facts[b].characters[c].character_z) {
                        highestz =
                          facts[b].characters[c].character_z > highestz ? facts[b].characters[c].character_z : highestz;
                      }
                      for (var d in facts[b].characters[c].assets) {
                        highestz =
                          facts[b].characters[c].assets[d].z > highestz ? facts[b].characters[c].assets[d].z : highestz;
                      }
                    }
                  }
                }

                char.character_z = highestz + 1;

                // Add new character to fact array, then update action & search history
                currentFact.characters.push(char);
                self.selectCharacter(char);
                self.addToHistory();
                $scope.$close();
              };
            },
          ],
        });
      },
      setImagesSearchSubType: function (type) {
        var self = this;

        if (EditorService.imagesSearchSubType === type) {
          return;
        }

        self.imagesSearchSubType = type;

        self.imagesSearchResults = [];
        self.imagesPagination = {};

        fallback = self.currentFact().picmonic ? self.currentFact().picmonic : self.currentFact().name;

        self.searchAssets('images', self.imagesQuery ? self.imagesQuery : fallback, 1);
      },
    };

    return EditorService;
  },
]);
